import React from 'react';
import { Link } from 'react-router-dom';
import './noEventsState.css';

/**
 * A friendly empty state component displayed when no events are found.
 * Provides helpful messaging and actionable advice.
 * @param {string} city - Optional city name for search context
 * @param {string} type - Optional type: 'favorites' for favorites page
 */
const NoEventsState = ({ city, type }) => {
  const isFavorites = type === 'favorites';
  
  return (
    <div className="no-events-container">
      <div className="no-events-icon">
        <i className={isFavorites ? "bi bi-heart" : "bi bi-calendar-x"}></i>
      </div>
      <h4 className="no-events-title">
        {isFavorites 
          ? "Aucun événement favori"
          : `Aucun événement trouvé${city ? " dans cette zone" : ""}`
        }
      </h4>
      <p className="no-events-text">
        {isFavorites
          ? "Parcourez les événements et ajoutez vos favoris en cliquant sur le cœur."
          : city 
            ? "Essayez d'augmenter le rayon de recherche ou de choisir une autre ville."
            : "Aucun événement n'est disponible pour le moment. Revenez bientôt !"
        }
      </p>
      <div className="no-events-suggestions">
        {isFavorites ? (
          <Link to="/" className="suggestion-badge suggestion-badge-link">
            <i className="bi bi-search me-1"></i>
            Découvrir les événements
          </Link>
        ) : (
          <>
            <span className="suggestion-badge">
              <i className="bi bi-geo-alt me-1"></i>
              Élargir la zone
            </span>
            <span className="suggestion-badge">
              <i className="bi bi-arrow-repeat me-1"></i>
              Revenir plus tard
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default NoEventsState;
